module.exports = __webpack_public_path__ + "img/首页轮播图3.fcc50860.jpg";